import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import Survey from './index.vue';
import SurveyMixins from './mixins';

var PublicSurveyPage = function (_super) {
  __extends(PublicSurveyPage, _super);

  function PublicSurveyPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.surveyDetails = _this.initDetails();
    _this.code = '';
    _this.surveyId = undefined;
    return _this;
  }

  PublicSurveyPage.prototype.created = function () {
    this.code = this.$route.query.code;
    this.queryQuestionList();
  };

  PublicSurveyPage.prototype.queryQuestionList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var params, res, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.code) {
              return [2];
            }

            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            params = {
              code: this.code
            };
            this.loading = true;
            this.isSuccessLoad = false;
            return [4, this.$api.survey.queryPublicSurveyDetails(params)];

          case 2:
            res = _a.sent();
            this.surveyDetails = res.data;
            this.loading = false;
            this.isSuccessLoad = true;
            return [3, 4];

          case 3:
            error_1 = _a.sent();
            this.loading = false;
            this.isSuccessLoad = false;
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  PublicSurveyPage.prototype.handleSubmit = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var res, error_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params.survey_id = this.surveyDetails.id;
            params.code = this.code;
            this.submitLoading = true;
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4, this.$api.survey.submitPublicSurvey(params)];

          case 2:
            res = _a.sent();
            this.isFinished = true;
            this.submitLoading = false;
            this.$router.push({
              name: 'PrivateSurveyPage',
              query: {}
            });
            return [3, 4];

          case 3:
            error_2 = _a.sent();
            this.submitLoading = false;
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  PublicSurveyPage = __decorate([Component({
    components: {
      Survey: Survey
    }
  })], PublicSurveyPage);
  return PublicSurveyPage;
}(Mixins(SurveyMixins));

export default PublicSurveyPage;